export default __webpack_public_path__ + "static/media/moltensteelslash4.eaffa33e.png";